module.exports = __webpack_public_path__ + "static/img/centerWineDialogImg.ac3cdae4.png";